import axios from "axios";
import { Cookie } from "../util/cookie";
import { REFRESH_TOKEN_API_URL } from "./apiPath";

export function CallWithOutAuth(method, url, body) {
  return new Promise((resolve, reject) => {
    try {
      if (method === "POST") {
        axios
          .post(url, body)
          .then((response) => {
          
            if (response.status === 200 || response.status === 201) {
              resolve({ status: true, res: response });
            } else {
              resolve({ status: false, res: response });
            }
          })
          .catch((err) => {
            resolve({ status: false, res: err.response });
          });
      }
      if (method === "PUT") {
        axios
          .put(url, body)
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              resolve({ status: true, res: response });
            } else {
              resolve({ status: false, res: response });
            }
          })
          .catch((err) => {
            resolve({ status: false, res: err.response });
          });
      }
      if (method === "PATCH") {
        axios
          .patch(url, body)
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              resolve({ status: true, res: response });
            } else {
              resolve({ status: false, res: response });
            }
          })
          .catch((err) => {
            resolve({ status: false, res: err.response });
          });
      }
      if (method === "GET") {
        axios
          .get(url, body)
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              resolve({ status: true, res: response });
            } else {
              resolve({ status: false, res: response });
            }
          })
          .catch((err) => {
            resolve({ status: false, res: err.response });
          });
      }
    } catch (err) {
      console.log("Catch block error in CallWithOutAuth method");
      console.log(err.response);
      reject(err.response);
    }
  });
}

const getAcceesToken = async () => {
  const refreshToken = Cookie.getCookie("refreshToken");
  if (!refreshToken) {
    return false;
  }

  try {
    const response = await axios.post(REFRESH_TOKEN_API_URL, {
      refresh_token: refreshToken
    }, {
      'Content-Type': "application/json"
    });

    if (response?.data?.data?.access_token) {
      localStorage.setItem("accessToken", response?.data?.data?.access_token);
      return true;
    } else {
      return false;
    }

  } catch (e) {
    return false;
  }
}

export function CallWithAuth(method, url, body = {}, token = null) {
  const header = {
    headers: { Authorization: `Bearer ${token || localStorage.getItem("accessToken")}` },
  };

  return new Promise((resolve, reject) => {
    try {
      if (method === "POST") {
        axios
          .post(url, body, header )
          .then((response) => {
            console.log(response)
            if (response.status === 200 || response.status === 201) {
              resolve({ status: true, res: response });
            } else {
              resolve({ status: false, res: response });
            }
          })
          .catch((err) => {
            if (!err?.response) {
              return resolve({ status: false, res: { status: 504, data: { message: "Request timed out" } } });
            }

            if (err.response.status === 504) {
              return resolve({ status: false, res: err.response });
            }

            if (err.response.status === 401) {
              if (token) {
                resolve({ status: false, res: err.response });
              } else {
                getAcceesToken().then(resp => {
                  if (resp) {
                    CallWithAuth(method, url, body, token).then(resolve);
                  } else {
                    localStorage.clear();
                    resolve({ status: false, res: err.response });
                  }
                })
              }
            } else {
              resolve({ status: false, res: err.response });
            }
          });
      }
      if (method === "PUT") {
        axios
          .put(url, body, header)
          .then((response) => {
            console.log(response);
            if (response.status === 200 || response.status === 201) {
              resolve({ status: true, res: response });
            } else {
              resolve({ status: false, res: response });
            }
          })
          .catch((err) => {
            if (!err?.response) {
              return resolve({ status: false, res: { status: 504, data: { message: "Request timed out" } } });
            }

            if (err.response.status === 504) {
              return resolve({ status: false, res: err.response });
            }

            if (err.response.status === 401) {
              if (token) {
                resolve({ status: false, res: err.response });
              } else {
                getAcceesToken().then(resp => {
                  if (resp) {
                    CallWithAuth(method, url, body, token).then(resolve);
                  } else {
                    localStorage.clear();
                    window.location.href="/login"
                    resolve({ status: false, res: err.response });
                  }
                })
              }
            } else {
              resolve({ status: false, res: err.response });
            }
          });
      }
      if (method === "PATCH") {
        axios
          .patch(url, body, header )
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              resolve({ status: true, res: response });
            } else {
              resolve({ status: false, res: response });
            }
          })
          .catch((err) => {
            if (!err?.response) {
              return resolve({ status: false, res: { status: 504, data: { message: "Request timed out" } } });
            }

            if (err.response.status === 504) {
              return resolve({ status: false, res: err.response });
            }

            if (err.response.status === 401) {
              if (token) {
                resolve({ status: false, res: err.response });
              } else {
                getAcceesToken().then(resp => {
                  if (resp) {
                    CallWithAuth(method, url, body, token).then(resolve);
                  } else {
                    localStorage.clear();
                    window.location.href="/login"
                    resolve({ status: false, res: err.response });
                  }
                })
              }
            } else {
              resolve({ status: false, res: err.response });
            }
          });
      }
      if (method === "GET") {
        axios
          .get(url, header )
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              resolve({ status: true, res: response });
            } else {
              resolve({ status: false, res: response });
            }
          })
          .catch((err) => {
            if (!err?.response) {
              return resolve({ status: false, res: { status: 504, data: { message: "Request timed out" } } });
            }

            if (err.response.status === 504) {
              return resolve({ status: false, res: err.response });
            }
            
            if(err.response.status === 401) {
              if (token) {
                resolve({ status: false, res: err.response });
              } else {
                getAcceesToken().then(resp => {
                  if (resp) {
                    CallWithAuth(method, url, body, token).then(resolve);
                  } else {
                    localStorage.clear();
                    resolve({ status: false, res: err.response });
                  }
                })
              }
            } else {
              resolve({ status: false, res: err.response });
            }
          });
      }
      if (method === "DELETE") {
        axios
          .delete(url,header)
          .then((response) => {
            if (response.status === 200 || response.status === 201) {
              resolve({ status: true, res: response });
            } else {
              resolve({ status: false, res: response });
            }
          })
          .catch((err) => {
            if (!err?.response) {
              return resolve({ status: false, res: { status: 504, data: { message: "Request timed out" } } });
            }

            if (err.response.status === 504) {
              return resolve({ status: false, res: err.response });
            }

            if(err.response.status === 401) {
              if (token) {
                resolve({ status: false, res: err.response });
              } else {
                getAcceesToken().then(resp => {
                  if (resp) {
                    CallWithAuth(method, url, body, token).then(resolve);
                  } else {
                    localStorage.clear();
                    window.location.href="/login"
                    resolve({ status: false, res: err.response });
                  }
                })
              }
            } else {
              resolve({ status: false, res: err.response });
            }
          });
      }
    } catch (err) {
      console.log("Catch block error in CallWithAuth method");
      console.log(err);
      reject(err.response);
    }
  });
}



export function CallWithFaceMatchAuth(method, url, body = {}, header={}) {

return new Promise((resolve, reject) => {
    try {
      if (method === "POST") {
        axios
          .post(url, body, header )
          .then((response) => {
            console.log(response)
            if (response.status === 200 || response.status === 201) {
              resolve({ status: true, res: response });
            } else {
              resolve({ status: false, res: response });
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              getAcceesToken().then(resp => {
                if (resp) {
                  CallWithAuth(method, url, body, header).then(resolve);
                } else {
                  localStorage.clear();
                  window.location.href="/login"
                  resolve({ status: false, res: err.response });
                }
              })
            } else {
              resolve({ status: false, res: err.response });
            }
          });
      }
      
    } catch (err) {
      console.log("Catch block error in CallWithAuth method");
      console.log(err);
      reject(err.response);
    }
  });

}